import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import flixfrenzy from '../assets/flixfrenzy.webp';
import './Styles.css';

const Help = () => {
  const allUsers = useSelector((state) => state.user);
  const navigate = useNavigate();
  return (

    <div className="credentials-page">
      <div className="credentials-page-header">
        <img className="header-logo" src={flixfrenzy} alt="flixfrenzy logo" />
      </div>
      <div className="help-container">
        <p className="welcome">Welcome To FlixFrenzy</p>
        <p className="help-message">
          Welcome to our website! We are thrilled to have you here. Below, we have prepared
          some useful information to help you explore and make the most out of our platform,
          showcasing a wide variety of movies and TV shows. Whether you&apos;re looking for
          entertainment
          suggestions or experiencing any issues, this help page is here to assist you.
        </p>
        <h2>Browsing our Collection</h2>
        <p className="help-message">
          <b>a. Search Bar:</b>
          {' '}
          At the top of every page, you will find a search bar where you can enter keywords
          to find specific movies or TV shows. Just type in the title, genre, actor, or director,
          and the search results will display matching options.
        </p>
        <p className="help-message">
          <b>b. Browse by Category:</b>
          {' '}
          On our homepage, you can explore different categories like Popular Movies, Trending
          TV Shows, Top Rated, New Releases, Genres, and more. Simply click on any category to
          delve into the corresponding collection.
        </p>

        <h2>Movie/TV Show Pages</h2>

        <p className="help-message">
          <b>Synopsis & Details:</b>
          {' '}
          Each movie or TV show page provides an overview, synopsis, release date, runtime,
          cast information, director, genre, and user ratings. You can also find related
          content, such as similar movies or TV shows.
        </p>
        <h2>Account & User Support</h2>

        <p className="help-message">
          <b>Account Creation:</b>
          {' '}
          While browsing our website, you may find it helpful to create an account. This
          will allow you to personalize your experience, create watchlists, rate content,
          and contribute to discussions.
        </p>
        <div className="other-links-section help-links">
          {allUsers.login === true ? (
            <button type="button" className="help-back" onClick={() => navigate(-1)}>Back</button>)
            : (
              <>
                <Link to="/sign-up" className="sign-up-link">Sign up now</Link>
                <Link to="/login" className="sign-up-link">Login</Link>
              </>
            ) }
        </div>
      </div>
    </div>
  );
};

export default Help;
